import React from "react"
import Modal from "react-bootstrap/Modal"
import Icon from "../Utils/Icon"
import * as styles from "./Styles/PlaceSwitchModal.module.scss"
import classNames from "classnames/bind"
const cn = classNames.bind(styles)

const PlaceSwitchModal = (props) => {
  return (
    <React.Fragment>
      <Modal show={props.show} onHide={props.onClose}>
        <Modal.Header className={styles.title} closeButton>
          編集可能な施設
        </Modal.Header>
        <Modal.Body>
          {props.places.map((place, i) => (
            <a
              key={i}
              href={place.path}
              className={cn(
                "link",
                place.id === props.place.id ? "link--active" : ""
              )}
            >
              <div className={styles.contents}>
                <div className={styles.check}>
                  {place.name === props.place.name && (
                    <Icon type="feather" name="check" />
                  )}
                </div>
                <div>{place.name}</div>
              </div>
            </a>
          ))}
        </Modal.Body>
      </Modal>
    </React.Fragment>
  )
}
export default PlaceSwitchModal
